import React from "react";
import { observer } from "mobx-react";

import "./style/default-view.scoped.scss";

const DocumentBookmark = observer(({ data, activity }) => {
    let categories;
    const name = activity.path === "name" ? data : data?.name;
    const bookmarkCategories = activity.bookmarkCategories ?? [];

    if (data instanceof Array) {
        categories = data;
    } else if (data?.categories instanceof Array) {
        categories = data.categories;
    }

    categories = categories?.map(
        (category) => bookmarkCategories.find((bc) => bc._id === category)?.name,
    );

    return (
        <div className="default">
            {name && (
                <div>
                    <b>Name:</b> {name}
                </div>
            )}

            {categories?.length > 0 && (
                <div>
                    <b>Categories:</b> {categories.join(", ")}
                </div>
            )}
        </div>
    );
});

export default DocumentBookmark;
